/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/string/GetSubstring.ts
 * @create:      2025-06-26 10:17:14.563
 * @modify:      2025-07-11 21:19:12.852
 * @version:     6.0.0
 * @times:       7
 * @lines:       48
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { StringPosition } from "../class/StringPosition";

/**
 * Returns a substring from the given string based on the specified start and end positions.
 *
 * @param str - The source string from which to extract the substring.
 * @param pos - An object containing `Start` and `End` properties that define the substring's range.
 * @returns The substring from `str` starting at `pos.Start` and ending at `pos.End`.
 * 
 * @since 4.0.0
 * @version 2021-12-14
 */
export function GetSubstring(str: string, pos: StringPosition) {
    return str.substring(pos.Start, pos.End);
}
